import { Directive, ElementRef, HostListener, Renderer2, StaticProvider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const TRIM_WHITESPACE_CONTROL_VALUE_ACCESSOR: StaticProvider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TrimWhitespaceDirective),
    multi: true
};

// modfied version of our remove whitespace directive
@Directive({
    selector: '[trim-whitespace]',
    providers: [TRIM_WHITESPACE_CONTROL_VALUE_ACCESSOR]
})
export class TrimWhitespaceDirective implements ControlValueAccessor {
    private onChange: (val: string) => void;
    private onTouched: () => void;
    private value: string;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
    }

    @HostListener('input', ['$event.target.value'])
    onInputChange(value: string) {
        const filteredValue: string = removeInitialWhitespace(value);
        this.updateTextInput(filteredValue, this.value !== filteredValue);
    }

    @HostListener('blur', ['$event.target.value'])
    onBlur(value: string) {
        const filteredValue: string = trimValue(value);
        this.updateTextInput(filteredValue, this.value !== filteredValue);
        if(this.onTouched) this.onTouched();
    }

    private updateTextInput(value: string, propagateChange: boolean) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
        if (propagateChange) {
            if(this.onChange) this.onChange(value);
        }
        this.value = value;
    }

    // ControlValueAccessor Interface
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }

    writeValue(value: any): void {
        value = value ? String(value) : '';
        this.updateTextInput(value, false);
    }
}

function removeInitialWhitespace(value: string): string {
    return value.replace(/^\s/g, "");
}
function trimValue(value: string): string {
    return value.trim();
}
